// FILE: src/pages/SystemRequirementsPage.jsx
// Public technology requirements (MTO 12.1), before registration.
import React from "react";
import { Typography } from "@mui/material";
import PublicLayout from "../layouts/PublicLayout";
import { PageHeader } from "../components/ui";
import SystemRequirements from "../components/SystemRequirements";

export default function SystemRequirementsPage() {
  return (
    <PublicLayout wide>
      <Typography variant="h1" sx={{ mb: 1 }}>
        System requirements
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 4, maxWidth: "65ch" }}>
        Check your device, browser and internet connection before you start. If something here doesn't work for you,
        contact student support: we can help.
      </Typography>
      <SystemRequirements />
    </PublicLayout>
  );
}

/** The same requirements inside the student area (MTO 12.1: always findable). */
export function StudentSystemRequirementsPage() {
  return (
    <>
      <PageHeader
        title="System requirements"
        description="The minimum device, browser and internet connection you need for the course. Having trouble? Contact technical support."
      />
      <SystemRequirements />
    </>
  );
}
